import {useNavigate} from 'react-router-dom';
import {
    FormPageLayout,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';

import {RecordForm} from '../forms/RecordForm';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {useTestDefinition} from '../hooks/useTestDefinition.ts';
import {buildInitialValues} from '../forms/buildInitialValues.ts';
import {TestDefinitionFormValues} from '../types.ts';
import config from '../config';

export const AddPage = () => {

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(config.basePath);
    };

    const {createRecord} = useTestDefinition();

    // Empty defaults. `status` is deliberately NOT seeded — the author picks it
    // explicitly and the schema requires it.
    const seededRecord = buildInitialValues();

    const handleSubmit = async (values: TestDefinitionFormValues) => {
        await createRecord(values);
        navigate(config.basePath);
    };

    return (
        <FormPageLayout
            title={`Add ${config.titles.singular}`}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm
                    record={seededRecord}
                    handleSubmit={handleSubmit}
                    handleCancel={onCancel}
                />
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
